import appDay from 'dayjs'
import duration from 'dayjs/plugin/duration'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

appDay.extend(duration)
appDay.extend(utc)
appDay.extend(timezone)

export { appDay }
